import { getToken } from './authentication';

export function getHeaders() {
  const token = getToken();

  if (!token) {
    throw new Error('Not authorised');
  }

  return {
    Authorization: `Bearer ${token}`
  };
}


// WEBPACK FOOTER //
// ./src/services/fetch.js